import React from "react";
import { Button, Link } from "@material-ui/core";
import moment from "moment";
import MechanicDropdown from "./MechanicDropdown";

export function parseDate(val) {
	if (isNullOrEmpty(val))
		return null;

	return new Date(Formatter(val, "DT"));
}
let timer;
export function debounce(func, timeout = 300) {
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => { func.apply(this, args); }, timeout);
	};
}

export function Formatter(data, typeCode, config) {
	var result = null;
	if (typeCode !== "MECHANIC") {
		if (data === null || data === "") {
			return "";
		}
	}
	switch (typeCode) {
		case "BUTTON":
			result = (
				<Button variant="contained" onClick={data.onClick}>
					{data.display}
				</Button>
			);
			break;
		case "D":
			result = moment(data).format("MM/DD/YYYY");
			// result = <Moment format="MM/DD/YYYY" date={data}></Moment>;
			break;
		case "DT":
			result = moment(data).format("MM/DD/YYYY hh:mm a");
			// result = <Moment format="MM/DD/YYYY" date={data}></Moment>;
			break;
		case "L":
			result = data ? "Yes" : "No";
			break;
		case "LINK":
			result = (
				<Link href="#" style={{ textDecoration: "underline" }} onClick={config.OnClick}>
					{data}
				</Link>
			);
			break;
		case "IMG":
			result = <img src={data} alt="No image available" style={{ maxWidth: "800px" }}></img>;
			break;
		case "ACTION":
			result = (
				<Button variant="contained" onClick={config.OnClick}>
					{data}
				</Button>
			);
			break;
		case "MECHANIC":
			result = <MechanicDropdown OnChange={config.OnChange}></MechanicDropdown>;
			break;
		case "$":
			var parsed = parseFloat(data);
			if (isNaN(parsed)) {
				parsed = 0.0;
			}
			result = "$" + parsed;

			if (result.indexOf(".") === -1) {
				result += ".00";
			}
			var i = result.length - 6;
			while (i > 1) {
				result = result.substr(0, i) + "," + result.substr(i);
				i -= 3;
			}
			break;
		case "S":
		default:
			result = data;
			break;
	}
	return result;
}

export function isNullOrEmpty(val) {
	return typeof val === "undefined" || val === null || val === "";
}

export function isNullOrUndefined(val) {
	return typeof val === "undefined" || val === null;
}

export function validateField(data, field, caption) {
	if (isNullOrEmpty(data[field])) {
		alert(caption + " is a required field.");
		return false;
	}

	return true;
}

export function isGuid(value) {
	var regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
	var match = regex.exec(value);
	return match != null;
}

export function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(";").shift();
}

export function getQueryStringVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		if (pair[0] == variable) {
			return pair[1];
		}
	}
	return false;
}
